import { useEffect, useRef, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';

// Text skrátený na „…“ – celý text v tooltipe, ale LEN keď je naozaj skrátený
// a až po chvíli (delay), aby pri prechádzaní zoznamu myšou nerušil.
const TruncatedText = ({ text, className, style, delay = 700 }) => {
  const ref = useRef(null);
  const timer = useRef(null);
  const [open, setOpen] = useState(false);

  useEffect(() => () => clearTimeout(timer.current), []);

  // Odpočet sa spustí pri vstupe AJ pri pohybe myši nad textom – keď už myš nad textom bola
  // (napr. po prekreslení zoznamu), mouseenter by neprišiel a tooltip by sa neukázal.
  const handleHover = () => {
    if (open || timer.current) return;
    const el = ref.current;
    // len text, ktorý naozaj prečnieva cez okraj (nulová šírka = panel sa práve otvára/zatvára)
    if (!el || el.clientWidth === 0 || el.scrollWidth <= el.clientWidth + 1) return;
    timer.current = setTimeout(() => { timer.current = null; setOpen(true); }, delay);
  };
  const handleLeave = () => {
    clearTimeout(timer.current);
    timer.current = null;
    setOpen(false);
  };

  return (
    <Tooltip
      title={text || ''}
      open={open}
      placement="bottom-start"
      disableHoverListener
      disableFocusListener
      disableTouchListener
      slotProps={{ tooltip: { className: 'truncated-tooltip' } }}
    >
      <span
        ref={ref}
        className={className}
        style={style}
        onMouseEnter={handleHover}
        onMouseMove={handleHover}
        onMouseLeave={handleLeave}
        onMouseDown={handleLeave}
      >
        {text}
      </span>
    </Tooltip>
  );
};

export default TruncatedText;
